import styled from "styled-components";

export default styled.div`
  position: fixed;
  opacity: ${props => (props.open ? 1 : 0)};
  left: 0;

  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/CustomDialog/DialogModal.js